module.exports = "fragment RegionalDirector on EmployeeType{__typename id fullName code}"